import { gql } from '@apollo/client';

export const fetchSandboxParentPPC = gql`
  query fetchSandboxParentPPC($id: String, $transactionAccountId: String, $fetchDetails: Boolean = false) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      productId
      entitlementNumber
      id
      edition
      productName
      billingFrequency @include(if: $fetchDetails)
      cloudSiteId @include(if: $fetchDetails)
      cloudSiteHostname @include(if: $fetchDetails)
      isFutureDatedSubscription @include(if: $fetchDetails)
      billingStatus @include(if: $fetchDetails)
      provisioningStatus @include(if: $fetchDetails)
      createdDate @include(if: $fetchDetails)
      latestPeriodEndDate @include(if: $fetchDetails)
      activeUsers @include(if: $fetchDetails)
      userTier @include(if: $fetchDetails)
    }
  }
`;
